export default __webpack_public_path__ + "static/media/japan.a16c066d.png";